<template>
    <aside class="o-sidebar" :class="{ 'is-active' : sidebarActive }">

        <div class="o-sidebar__close" @click="closeSidebar()">
            <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="m13.4141 12 4.293-4.293a.9989.9989 0 0 0 0-1.414.9989.9989 0 0 0-1.414 0l-4.293 4.293-4.293-4.293a.9989.9989 0 0 0-1.414 0 .9989.9989 0 0 0 0 1.414L10.5861 12l-4.293 4.293a.9989.9989 0 0 0 0 1.414c.195.195.451.293.707.293.256 0 .512-.098.707-.293l4.293-4.293 4.293 4.293c.195.195.451.293.707.293.256 0 .512-.098.707-.293a.9989.9989 0 0 0 0-1.414L13.4141 12Z" id="close"/></defs><use fill="#212550" fill-rule="nonzero" xlink:href="#close"/></svg>
        </div>

        <div class="c-logo margin-b-40">
            <router-link :to="{name: 'dashboard'}">
                <img src="/img/logo.svg" height="48" width="161">
            </router-link>
        </div>

        <c-avatar class="margin-b-40"></c-avatar>

        <nav class="c-nav">

            <router-link v-if="can('Dashboard bekijken')" :to="{name: 'statistics'}" :class="{'is-active': $route.meta && $route.name == 'statistics' }" class="c-nav__item">
                <div class="c-nav__title">
                    Dashboard
                </div>
            </router-link>

            <router-link :to="{name: 'dashboard'}" :class="{'is-active': $route.meta && $route.name == 'dashboard' || $route.name == 'customerDetail' }" class="c-nav__item" v-if="can('Klant bekijken')">
                <div class="c-nav__title">
                    CRM
                </div>
            </router-link>

            <router-link :to="{name: 'stock'}" class="c-nav__item " :class="{'is-active': $route.meta && $route.name == 'stock' || $route.name == 'stockDetail' || $route.name == 'itemDetail'}" v-if="can('Voorraad bekijken')">
                <div class="c-nav__title">
                    Voorraad
                </div>
            </router-link>

            <router-link :to="{name: 'PreNotification'}" :class="{'is-active': $route.meta && $route.name == 'PreNotification' || $route.name == 'preNotificationDetail' }" class="c-nav__item" v-if="can('Voormelding bekijken')">
                <div class="c-nav__title">
                    Voormeldingen
                </div>
            </router-link>
             <router-link :to="{name: 'deliveryPickUp'}" :class="{'is-active': $route.meta && $route.name == 'deliveryPickup' || $route.name == 'deliveryDetail' }" class="c-nav__item" v-if="can('Levering bekijken')">
                <div class="c-nav__title">
                    Leveringen
                </div>
            </router-link>
            <router-link :to="{name: 'repair'}" :class="{'is-active': $route.meta && $route.name == 'repair' || $route.name == 'repairDetail' }" class="c-nav__item" v-if="can('Levering bekijken')">
                <div class="c-nav__title">
                    Reparatie overzicht
                </div>
            </router-link>
            <router-link :to="{name: 'eol'}" :class="{'is-active': $route.meta && $route.name == 'eol' || $route.name == 'EOLDetail' }" class="c-nav__item">
                <div class="c-nav__title">
                    EOL overzicht
                </div>
            </router-link>
            <router-link :to="{name: 'userManagement'}" :class="{'is-active': $route.meta && $route.name == 'userManagement' || $route.name == 'userDetails' }" class="c-nav__item" v-if="can('Gebruiker bekijken')">
                <div class="c-nav__title">
                    Gebruikersbeheer
                </div>
            </router-link>

            <router-link :to="{name: 'rolesRights'}" :class="{'is-active': $route.meta && $route.name == 'rolesRights' || $route.name == 'rolesRightsDetail' }" class="c-nav__item" v-if="can('Rol bekijken')">
                <div class="c-nav__title">
                    Rollen en rechten
                </div>
            </router-link>

            <router-link :to="{name: 'settings'}" :class="{'is-active': $route.meta && $route.name == 'settings' }" class="c-nav__item">
                <div class="c-nav__title">
                    Instellingen
                </div>
            </router-link>
        </nav>

        <div class="o-sidebar__footer">
            <a class="c-link color-secondary fw-medium" @click="openConfirmModal">
                <svg width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M7 4c.55 0 1 .45 1 1s-.45 1-1 1H6v12h1c.55 0 1 .45 1 1s-.45 1-1 1H5c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1Zm9.6109 3.1818c.451-.319 1.075-.209 1.393.243l2.814 4c.25.354.242.829-.018 1.175l-3 4a.998.998 0 0 1-.801.4.9962.9962 0 0 1-.599-.2c-.442-.331-.531-.958-.2-1.399l1.801-2.401h-8.001c-.552 0-1-.447-1-1 0-.553.448-1 1-1h8c.03 0 .056.015.086.018l-1.718-2.443c-.318-.451-.209-1.075.243-1.393Z" id="logout"/></defs><use fill="currentColor" fill-rule="nonzero" transform="matrix(-1 0 0 1 25.0003 0)" xlink:href="#logout"/></svg>
                Uitloggen
            </a>
        </div>

    </aside>

    <div @click="closeSidebar()" class="o-sidebar__overlay"></div>

    <c-confirm-logout
        v-show="modalCofirmLogout"
        @close="modalCofirmLogout = false">
    </c-confirm-logout>

</template>

<script>
import CAvatar from '@components/Avatar';
import CConfirmLogout from '@app/modals/ConfirmLogout';
import { mapGetters, mapState } from 'vuex';

export default {
    data() {
        return {
            sidebarActive: false,
            modalCofirmLogout: false
        }
    },
    components: {
        CAvatar, CConfirmLogout
    },
    methods: {
        logout() {
            this.$store.dispatch('user/logout');
        },
        toggleSidebar () {
            this.sidebarActive = !this.sidebarActive;
        },
        closeSidebar() {
            this.sidebarActive = false;
        },
        openSidebar() {
            this.sidebarActive = true;
        },
        openConfirmModal() {
            this.sidebarActive = false;
            this.modalCofirmLogout = true;
        }
    },
    computed: {
        ...mapState({
            user: state => state.user.data
        }),
        ...mapGetters({
            can: 'user/can'
        }),

    },
    watch: {
        $route() {
            this.sidebarActive = false;
        }
    },
    created() {
		this.$store.dispatch('listener/on', {
			event: 'open-sidebar',
			listener: this.openSidebar
		});
	},
	beforeUnmount() {
		this.$store.dispatch('listener/off', {
			event: 'open-sidebar',
			listener: this.openSidebar
		});
	},
}
</script>
